(function(b,c){var $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);


$(function() {

	var filterBlocked = false;

	var debouncedSend = $.debounce(1000, function($form) {
		if (!filterBlocked) {
			$($form).trigger("ajaxify");
		}
	});

	function initAjaxFilters() {

		//-----click filter-----------------------------------
		$("#filter form").ajaxify({

			refresh: [
				"#filter",
				"#refresh-target"
			],
			history: false,
			onStart: function(data) {
				data.sourceElement.closest('#filter form').addClass('c-filter__loader');
				filterBlocked = true;
			},
			onFinish: function() {
				filterBlocked = false;
				initAjaxFilters();
				$("#next-page-button").ajaxNextEshopPage({
					"containerId": "refresh-target",
					"buttonId": "next-page-button",
					//"alsoRefresh": ["#paginator-bottom","#paginator-top","#next-page-button"],
					"loadingClass": "now-loading",
					"success": function() {
						initAjaxCounters2();
					}
				});
			}
		});
		$("#filter input:checkbox").click(function() {
			debouncedSend($(this).closest("form"));
		});

	}

	$(function() {
		initAjaxFilters();
	});
});
